import React from 'react';
import CheckInput from '../Components/Common/Atoms/Form/CheckInput';
import InputBox from '../Components/Common/Atoms/Form/InputBox';

const Map = (suscripciones, clickHandler, suscripcionesSeleccionadas, invalid) => {
    return suscripciones.map((suscripcion, key) => {
        return (
            <InputBox
                key={key}
                value={suscripcion.IdSuscripcion}
                error={!suscripcionesSeleccionadas.length && invalid ? true : false}
                success={(suscripcionesSeleccionadas.length > 0 && invalid === false) ? true : false}
                disabled={suscripcion.Estado === 5}
                input={
                    <CheckInput onChange={clickHandler} value={suscripcion.IdSuscripcion} disabled={suscripcion.Estado === 5}>
                        {suscripcion.PlanDeVenta.NombreAmigable}
                    </CheckInput>
                }
            />
        );
    });
};

export default Map;
